import { useState } from 'preact/hooks';

export function PasswordEntry({ onPasswordCorrect }: { onPasswordCorrect: () => void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e: Event) => {
    e.preventDefault();
    if (password === import.meta.env.VITE_APP_PASSWORD) {
      onPasswordCorrect();
    } else {
      setError(true);
    }
  };

  return (
    <div style={{
      backgroundColor: '#0d1117',
      color: '#c9d1d9',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"'
    }}>
      <form onSubmit={handleSubmit} style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '24px',
        border: '1px solid #30363d',
        borderRadius: '6px',
        backgroundColor: '#161b22'
      }}>
        <h1 style={{ fontSize: '24px', fontWeight: '600', margin: '0' }}>Enter Password</h1>
        <input
          type="password"
          value={password}
          onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
          style={{
            padding: '5px 12px',
            backgroundColor: '#0d1117',
            border: '1px solid #30363d',
            borderRadius: '6px',
            color: '#c9d1d9'
          }}
        />
        <button type="submit" style={{
          padding: '5px 16px',
          backgroundColor: '#238636',
          color: '#ffffff',
          border: '1px solid rgba(240, 246, 252, 0.1)',
          borderRadius: '6px',
          cursor: 'pointer'
        }}>
          Enter
        </button>
        {error && <p style={{ color: '#f85149', margin: '0' }}>Incorrect password</p>}
      </form>
    </div>
  );
}